import React from 'react';
import { useHistory } from 'react-router-dom';
import CompanySearchWrapper from '@componentsV2/CompanySearch';
import Page from '../../../../components/layouts/WithHeader';
import useDesktop from '../../../../hooks/useDesktop';

/**
 * Company Search Page
 * Demonstrates usage of the CompanySearchWrapper component
 * with Search API authentication integration
 */
const CompanySearchPage = () => {
  const isDesktop = useDesktop();
  const history = useHistory();

  const handleResultsChange = () => {
    // Search results are handled by the CompanySearchWrapper component
  };

  const handleResultClick = (company) => {
    // Navigate to company profile page
    // Adjust the route based on your routing structure
    const boligmappaNumber = window.location.pathname.split('/')[2];
    if (boligmappaNumber) {
      history.push(
        `/dashboard/${boligmappaNumber}/company/${company.companyId}`
      );
    }
  };

  const handleCompanyMapClick = (company) => {
    handleResultClick(company);
  };

  return (
    <Page
      minFullHeight
      noPadding={!isDesktop}
      headerTitle="Søk etter bedrifter"
      lessMarginLeft={isDesktop}
      maxWidth="lg"
    >
      <div className="p-4 md:p-6">
        <CompanySearchWrapper
          onResultsChange={handleResultsChange}
          onResultClick={handleResultClick}
          onCompanyClick={handleCompanyMapClick}
          pageSize={15}
          showMap={isDesktop}
        />
      </div>
    </Page>
  );
};

export default CompanySearchPage;
